import { CircularProgress } from '@mgmresorts/mgm-ui';
import React from 'react';

import { StyledWrapper, StyledTitle, StyledIcon } from './styles';

interface LoaderProps {
  icon?: React.ReactNode;
  title?: string;
}

export const Loader = ({ icon, title }: LoaderProps) => {
  const loaderIcon = icon ?? <CircularProgress size={44} indeterminate />;
  return (
    <StyledWrapper data-testid='Loader'>
      <div>
        {title && (
          <StyledTitle variant='heading-medium-2' testId='loader-title'>
            {title}
          </StyledTitle>
        )}
        {loaderIcon && <StyledIcon data-testid='loader-icon'>{loaderIcon}</StyledIcon>}
      </div>
    </StyledWrapper>
  );
};

Loader.displayName = 'Loader';
